<dx-popup
  [(visible)]="showModal"
  [showTitle]="false"
  [showCloseButton]="false"
  [width]="'90%'"
  [maxWidth]="560"
  [height]="'auto'"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [wrapperAttr]="{ 
    class: 'provided-tenant-subscription-popup' 
  }"
  class="modal"
  [classList]="'modal'"
>
  <div *dxTemplate="let data of 'content'">

    <div class="provided-tenant-subscription">
      <h2 class="pts-title">
        {{ 
          'ONBOARDING.PROVIDED-TENANT-SUBSCRIPTION.TITLE'
            | translate: { tenantName: tenantName } 
        }}
      </h2>
      <p
        class="pts-description"
        [innerHTML]="
          'ONBOARDING.PROVIDED-TENANT-SUBSCRIPTION.DESCRIPTION'
            | translate: { tenantName: tenantName }
        "
      ></p>

      <div class="pts-publisher-card">
        <div class="pts-publisher-info">
          <span class="pts-publisher-name">
            {{ tenantName }}
          </span>
          <span class="pts-publisher-meta">
            {{ 'COMMON.PUBLISHER' | translate }}
            &middot;
            <span
              [innerHTML]="
                'ONBOARDING.PROVIDED-TENANT-SUBSCRIPTION.INVITED-ON'
                  | translate: { date: (invitedDate | date: 'dd MMM yyyy') }
              "
            ></span>
          </span>
        </div>
      </div>

      <div class="pts-stats">
        <div class="pts-stat-box">
          <span class="pts-stat-value">{{ trainingsCount }}</span>
          <span class="pts-stat-label">
            {{ 'ONBOARDING.PROVIDED-TENANT-SUBSCRIPTION.TRAININGS-WEBINARS' | translate }}
          </span>
        </div>
        <div class="pts-stat-box">
          <span class="pts-stat-value">{{ categoriesCount }}</span>
          <span class="pts-stat-label">
            {{ 'ONBOARDING.PROVIDED-TENANT-SUBSCRIPTION.CATEGORIES-IN-CATALOGUE' | translate }}
          </span>
        </div>
      </div>

      <div class="pts-checklist">
        <div class="pts-checklist-item">
          <i class="dx-icon-check pts-check-icon"></i>
          <span
            [innerHTML]="
              'ONBOARDING.PROVIDED-TENANT-SUBSCRIPTION.EXPLANATION' | translate
            "
          ></span>
        </div>
        <div class="pts-checklist-item">
          <i class="dx-icon-check pts-check-icon"></i>
          <div>
            <span
              [innerHTML]="
                'ONBOARDING.PROVIDED-TENANT-SUBSCRIPTION.MANUAL-OPTION-1' | translate
              "
            ></span>
            <span
              class="subscription-settings"
              [innerHTML]="
                'ONBOARDING.PROVIDED-TENANT-SUBSCRIPTION.MANUAL-OPTION-2' | translate
              "
            ></span>
          </div>
        </div>
      </div>

      <div class="pts-mapping-toggle" (click)="toggleMappingSection()">
        <i
          class="pts-mapping-chevron"
          [class.dx-icon-chevronup]="showMapping"
          [class.dx-icon-chevrondown]="!showMapping"
        ></i>
        <span>
          {{
            'ONBOARDING.PROVIDED-TENANT-SUBSCRIPTION.SHOW-CATEGORY-MAPPING'
              | translate: { count: standardCategories.length }
          }}
        </span>
      </div>

      <div class="pts-mapping-section" *ngIf="showMapping">
        <p 
          class="pts-mapping-hint"
          [innerHTML]="
            'ONBOARDING.PROVIDED-TENANT-SUBSCRIPTION.MAPPING-HINT' | translate
          "
        ></p>

        <div class="pts-mapping-list">
          <div
            class="pts-mapping-row"
            *ngFor="let category of standardCategories"
          >
            <div class="pts-mapping-labels">
              <span class="pts-mapping-source">{{ category.name }}</span>
              <i class="dx-icon-arrowright pts-mapping-arrow"></i>
              <span class="pts-mapping-target">{{ category.name }}</span>
              <span class="pts-mapping-badge">
                {{ 'COMMON.STANDARD' | translate }}
              </span>
            </div>

            <mat-slide-toggle
              [ngModel]="!disabledStandardCategoryIds.includes(category.id)"
              (ngModelChange)="onCategoryEnabledChanged(category.id, $event)"
              class="req-toggle"
            ></mat-slide-toggle>
          </div>
        </div>
      </div>
    </div>
  </div>

  <dxi-popup-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="skipButtonOptions"
  ></dxi-popup-toolbar-item>

  <dxi-popup-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="subscribeButtonOptions"
  ></dxi-popup-toolbar-item>
</dx-popup>